import { SelectOption } from '@fleet-beat/core';

export enum DocumentTypeEnum {
  license = 'License',
  dotRegistration = 'DOT Registration',
  driverCertificates = "Driver's Certificates of Insurance",
  medicalCard = 'Medical Card',
  iftaFuelTaxLicense = 'IFTA Fuel Tax License',
  ucrRegistration = 'UCR Registration',
  salesTaxExemption = 'General Sales Tax Exemption Certificate',
  insuranceCertificates = 'Certificates of Insurance',
  dotInspectionTruck = 'Current Annual DOT Inspection Report for Truck',
  truckRegistration = 'Truck Registration',
  rentalAgreement = 'Rental Agreement Sheet',
  truckVinCode = 'Truck VIN code',

  other = 'Other',
}

export const UserDocumentType: SelectOption[] = [
  { value: DocumentTypeEnum.license, label: 'License' },
  { value: DocumentTypeEnum.dotRegistration, label: 'DOT Registration' },
  { value: DocumentTypeEnum.driverCertificates, label: "Driver's Certificates of Insurance" },
  { value: DocumentTypeEnum.medicalCard, label: 'Medical Card' },
  { value: DocumentTypeEnum.iftaFuelTaxLicense, label: 'IFTA Fuel Tax License' },
  { value: DocumentTypeEnum.ucrRegistration, label: 'UCR Registration' },
  { value: DocumentTypeEnum.salesTaxExemption, label: 'General Sales Tax Exemption Certificate' },
];

export const OwnTruckDocumentType: SelectOption[] = [
  { value: DocumentTypeEnum.insuranceCertificates, label: 'Certificates of Insurance' },
  { value: DocumentTypeEnum.dotInspectionTruck, label: 'Current Annual DOT Inspection Report for Truck' },
  { value: DocumentTypeEnum.truckVinCode, label: 'Truck VIN code' },
];

export const RentTruckDocumentType: SelectOption[] = [
  { value: DocumentTypeEnum.truckRegistration, label: 'Truck Registration' },
  { value: DocumentTypeEnum.rentalAgreement, label: 'Rental Agreement Sheet' },
  { value: DocumentTypeEnum.insuranceCertificates, label: 'Certificates of Insurance' },
  { value: DocumentTypeEnum.dotInspectionTruck, label: 'Current Annual DOT Inspection Report for Truck' },
  { value: DocumentTypeEnum.truckVinCode, label: 'Truck VIN code' },
];
